import { Auth } from 'aws-amplify'

type FypUpdatePassword = {
  email: string
  verificationCode: string
  password: string
}

// `cognitoAction` associated with `ForgotPasswordConfirmationForm`
export async function forgotPasswordUpdatePassword(
  values: FypUpdatePassword
): Promise<void> {
  const { email, verificationCode, password } = values

  if (window.Cypress) {
    const AuthMocked = await import(
      '@util/amplify-mock-implementations/mocked-cognito-api'
    )
    AuthMocked.default.forgotPasswordSubmit(email, verificationCode, password)
    return
  }

  await Auth.forgotPasswordSubmit(email, verificationCode, password)
}
